import { Flex } from '@mantine/core';
import { IconHome } from '@tabler/icons';
import { useAuth } from '../../hooks/useAuth';
import { UserRole, UserType } from '../../models/user';
import { AppRoutePaths } from '../../utils/enums/routes';
import { rootNavigate } from '../custom-router';
import { NavButton } from '../nav-button';
import { CashFlowLink } from './links/cash-flow';
import { EmployeeTransportLink } from './links/employee-transport';
import { UserLink } from './links/user-link';
import { HourHistoryLink } from './links/work-history-link';
import { CompanyLink } from './links/company-link';
import { BankHoursLink } from './links/bank-hours-link';
import { WorkScaleLink } from './links/work-scale-link';
import { WorkAlertsLink } from './links/work-alerts';
import { SystemLink } from './links/system-link';
import { EpiLink } from './links/epi-link';
import { SectorDailyLogsLink } from './links/sector-daily-logs-link';

interface SidebarProps {
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

export function Sidebar({ setOpened }: SidebarProps) {
  const { user } = useAuth();
  const isMaster = user?.user.type === UserType.MASTER;
  const canViewCashFlow =
    user?.user.role === UserRole.MANAGER_CREATOR || isMaster;

  function navigate(to: string) {
    rootNavigate(to);
    setOpened(false);
  }

  return (
    <>
      <Flex direction="column">
        <NavButton
          text="Inicio"
          onClick={() => navigate(AppRoutePaths.HOME)}
          icon={<IconHome size={16} />}
          color={'gray'}
        />
        <WorkAlertsLink navigate={navigate} />
        <UserLink navigate={navigate} />
        <CompanyLink navigate={navigate} />
        <EpiLink navigate={navigate} />
        <SectorDailyLogsLink navigate={navigate} />
        <HourHistoryLink navigate={navigate} />
        {canViewCashFlow && <CashFlowLink navigate={navigate} />}
        <EmployeeTransportLink navigate={navigate} />
        <BankHoursLink navigate={navigate} />
        <WorkScaleLink navigate={navigate} />
        {isMaster && <SystemLink navigate={navigate} />}
      </Flex>
    </>
  );
}
